import { useState } from "react"
import { PageNav } from "@/components"
import { DataTable, Column } from "./DataTable"

export interface PageTableProps<T> {
  className?: string
  columns: Column<T>[]
  data: T[]
  defaultPage?: number
  totalPages: number
  maxHeight?: string
  onPageChange?: (page: number) => void
}

const PageTable = <T,>({
  className,
  columns,
  data,
  defaultPage = 1,
  totalPages,
  maxHeight,
  onPageChange,
}: PageTableProps<T>) => {
  const [page, setPage] = useState<number>(defaultPage)

  const handlePageChange = (page: number) => {
    setPage(page)
    onPageChange?.(page)
  }

  return (
    <>
      <DataTable columns={columns} data={data} maxHeight={maxHeight} />
      <PageNav
        className={className}
        page={page}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </>
  )
}

export default PageTable
